import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private loadingService: LoadingService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const startTime = Date.now();
    let timeout: any;

    timeout = setTimeout(() => {
      this.loadingService.show();
    }, 500);

    return next.handle(request).pipe(
      catchError((error) => {
        this.loadingService.hide();
        clearTimeout(timeout);
        throw error;
      }),
      finalize(() => {
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime < 500) {
          clearTimeout(timeout);
          this.loadingService.hide();
        } else {
          this.loadingService.hide();
        }
      })
    );
  }
}
